export enum NdsPopoverPlacement {
  AUTO = 'auto',
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
  TOP_START = 'top-start',
  TOP_END = 'top-end',
  RIGHT_START = 'right-start',
  RIGHT_END = 'right-end',
  BOTTOM_START = 'bottom-start',
  BOTTOM_END = 'bottom-end',
  LEFT_START = 'left-start',
  LEFT_END = 'left-end',
}

export enum NdsPopoverPosition {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
}
